import { KeyValue } from '@angular/common';
import { IMappedTaxRateSchedule } from 'src/app/models/tax';
import { Country } from '../../models/country';
export interface IUtilitiesState {
    countries: Country[];
    taxRateSchedule: IMappedTaxRateSchedule;
}

export const initialUtilitiesState: IUtilitiesState = {
    countries: [],
    taxRateSchedule: {}
};
